export default "/react/logoTgMaps-3265a612.png";